<template>
  <div class="row">

    <transition name="el-fade-in-linear" mode="out-in">
      
      <div key="History" class="col-md-12 card">
        <div class="card-header">
          <h4 class="card-title">Referral History</h4>
          <div class="category">Past verifications requested by your referrals</div>
        </div>
        <div class="card-content row form-horizontal">
          <div class="filters form-group" style="margin-left: 0">
            <transition name="el-fade-in-linear" mode="out-in">
              <div key="filtersClose" v-if="!filtersOpen">
                <div class="col-sm-10">
                  <el-input placeholder="Quick Search" prefix-icon="el-icon-search" v-model="query" :clearable="true" style="width: 100% !important"></el-input>
                </div>
                <div class="col-sm-2">
                  <button @click.prevent="filtersOpen = true" class="btn btn-fill btn-wd btn-default pull-right"><i class="fa fa-filter"></i>&nbsp;Filters {{filtersCount}}</button>
                </div>
              </div>
              <div key="filtersOpen" v-else="filtersOpen" class="col-sm-12 card-plain">
                <div class="el-collapse">
                  <div class="el-collapse-item is-active">
                    <div role="tab" style="margin-bottom: 15px">
                      <div @click="filtersOpen= false" role="button" class="el-collapse-item__header pull-right">
                        <i class="fa fa-times pull-right"></i>
                      </div>
                    </div>
                    <div role="tabpanel" class="el-collapse-item__wrap">
                      <div class="el-collapse-item__content"> 
                        <div class="form-horizontal">
                          <div class="form-group">
                            <label class="col-sm-2 control-label">Name or QCID</label>
                            <div class="col-sm-10">
                              <el-input placeholder="All" prefix-icon="el-icon-search" v-model="query" :clearable="true"></el-input>
                              <span class="help-block">Search by first, last or full name, or by QCID.</span>
                            </div>
                          </div>
                                                    
                          <div v-if="!$store.state.isIndividual" class="form-group">
                            <label class="col-sm-2 control-label">Requested By</label>
                            <div class="col-sm-10">
                              
                              <referral-select v-model="requestedBy" :includePending="false" />
                              <span class="help-block">Search by the referral who submitted the requested.</span>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="col-sm-2 control-label">Date</label>
                            <div class="col-sm-10">
                              <el-date-picker
                                v-model="dateRange"
                                type="daterange"
                                size="large"
                                :editable="false"
                                start-placeholder="Start date"
                                end-placeholder="End date"
                                value-format="yyyy-MM-dd"
                                :default-value="defaultDate"
                                :picker-options="pickerOptions">
                              </el-date-picker>
                              <span class="help-block">Show only verifications on or between these dates.</span>
                            </div>
                          </div>

                          <!-- <div class="form-group">
                            <label class="col-sm-2 control-label">Result</label>
                            <div class="col-sm-10">
                              <el-select multiple
                                        v-model="internalResults"
                                        :clearable="true"
                                        placeholder="All">
                                <el-option value="INCOMPLETE" label="Incomplete" />
                                <el-option value="ACTION" label="Action Required" />
                                <el-option value="VERIFIED" label="Verified" />
                                <el-option value="NOT_VERIFIED" label="Not Verified" />
                                <el-option value="PENDING" label="Pending" />
                                <el-option value="CANCELLED" label="Cancelled" />
                                <el-option value="UNABLE" label="Unable to Verify" />
                              </el-select>
                              <span class="help-block">Select multiple results or <a @click.prevent="clearResults" href="#">clear</a> for all results.</span>
                            </div>
                          </div> -->

                          <!-- <div class="form-group">
                            <label class="col-sm-2 control-label">Type</label>
                            <div class="col-sm-10">
                              <el-select multiple
                                        v-model="types"
                                        :clearable="true"
                                        placeholder="All">
                                <el-option value="edu" label="Education" />
                                <el-option value="emp" label="Employment" />
                              </el-select>
                              <span class="help-block">Select multiple types or <a @click.prevent="clearTypes" href="#">clear</a> for all types.</span>
                            </div>
                          </div> -->

                          <div class="form-group">
                            <label class="col-sm-2 control-label"></label>
                            <div class="col-sm-10">
                              <button @click.prevent="clearFilters" class="btn btn-default btn-fill btn-wd">Clear All</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <referral-verification-history-table
            :query="query"
            :requestedBy="requestedByName"
            :dateRange="dateRange"
          />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import ReferralVerificationHistoryTable from 'src/views/Referrals/components/ReferralHistoryTable'

  import {DatePicker} from 'element-ui'

  import ReferralSelect from 'src/components/Inputs/ReferralSelect'

  import moment from 'moment'
  import _ from 'lodash'

  export default {
    name: "referral-verification-history",
    components: {
      [DatePicker.name]: DatePicker,
      ReferralSelect,
      'referral-verification-history-table': ReferralVerificationHistoryTable
    },
    data () {
      return {
        result: null,
        query: "",
        requestedBy: "",
        // internalResults: [],
        // results: [],
        // types: [],
        dateRange: [],
        filtersOpen: false,
        pickerOptions: {
          disabledDate (date) {
            return date > new Date()
          },
          shortcuts: [
            {
              text: 'Last week',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: 'Last month',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: 'Last 3 months',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        }
      }
    },
    mounted () {
      // if(this.$route.query.result) {
      //   this.internalResults = []
      //   this.internalResults.push(this.$route.query.result)
      // }
    },
    activated () {
      // if(this.$route.query.result) {
      //   this.internalResults = []
      //   this.internalResults.push(this.$route.query.result)
      // }
    },
    watch: {
      // internalResults: _.debounce(function  (value) {
      //   var newResults = []
      //   value.forEach(function (result) {
      //     if(result === 'ACTION') {
      //       newResults.push('NOT_FOUND')
      //       newResults.push('REJECTED')
      //     } else if(result === 'INCOMPLETE') {
      //       newResults.push('UNPAID')
      //       newResults.push('AWAITING_CONSENT')
      //     } else {
      //       newResults.push(result)
      //     }
      //   })
      //   this.results = newResults
      // }, 500),
      dateRange(value) {
        if(value == null) {
          this.dateRange = []
        }
      }
    },
    computed: {
      requestedByName() {
        return this.requestedBy
      },
      filtersCount () {
        var count = 0
        if(this.query) count++
        if(this.customerReference) count++
        if(this.dateRange.length > 0) count++
        // if(this.results.length > 0) count++
        // if(this.types.length > 0) count++
        return count > 0 ? "(" + count + ")" : ""
      },
      defaultDate() {
        return moment().subtract(1, 'months').format('YYYY-MM-DD');
      }
    },
    methods: {
      filtersChange (activeNames) {
        var _this = this;
        setTimeout(function () {
          _this.filtersOpen = activeNames.includes("open")
        }, 0);
      },
      // clearResults () {
      //   this.results = []
      //   this.internalResults = []
      //   this.$store.commit('setHistoryFilters', {results: []})
      // },
      // clearTypes () {
      //   this.types = []
      // },
      clearFilters () {
        this.query = ""
        this.requestedBy = ""
        // this.results = []
        // this.internalResults = []
        // this.types = []
        this.dateRange = []
        this.$store.commit('clearHistoryFilters', null)
      }
    }
  }
</script>
<style>

</style>
